import { VARIATION_PRICE_TYPES } from './constants';

export const getVariationOptionLabel = (min, max, showOptionText = true) => {
  if (!min || !max) {
    return 'Sem limite de opções';
  } else if (max === 1) {
    return 'Apenas 1 opção (obrigatório)';
  }

  const minText = `Mín. ${showOptionText ? checkQuantity(min) : min}`;
  const maxText = `Máx. ${showOptionText ? checkQuantity(max) : max}`;

  return `${minText} / ${maxText}`;
};

export const checkQuantity = val => {
  return `${val} ${val > 1 ? 'opções' : 'opção'}`;
};

export const getVariationsPriceTypeLabel = priceType => {
  switch (priceType) {
    case VARIATION_PRICE_TYPES.totalSum:
      return 'Soma Total';
    case VARIATION_PRICE_TYPES.averagePrice:
      return 'Preço Médio';
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/helpers/variations.js